import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import styles from './form-builder-content.module.scss'
import { CheckboxDraggable } from '../form-items-draggable/checkbox-draggable'
import { DateDraggable } from '../form-items-draggable/date-draggable'
import { DateRangeDraggable } from '../form-items-draggable/date-range-draggable'
import { DownloadDraggable } from '../form-items-draggable/download-draggable'
import { HeaderDraggable } from '../form-items-draggable/header-draggable'
import { ImageUploadDraggable } from '../form-items-draggable/image-upload.draggable'
import { ListDraggable } from '../form-items-draggable/list-draggable'
import { NumberDraggable } from '../form-items-draggable/number-draggable'
import { NumberRangeDraggable } from '../form-items-draggable/number-range-draggable'
import { RadioDraggable } from '../form-items-draggable/radio-draggable'
import { TextDraggable } from '../form-items-draggable/text-draggable'
import { TextareaDraggable } from '../form-items-draggable/textarea-draggable'

type FormBuilderContentProps = {
  className?: string
}

export const FormBuilderContent = ({ className }: FormBuilderContentProps) => {
  const { t } = useTranslation()

  return (
    <div className={clsx(styles.wrapper, className, 'pt-3 px-4')}>
      <h6>{t('formBuilder.content.header')}</h6>

      <div className={clsx('pt-3')}>
        <HeaderDraggable />
        <TextDraggable />
        <TextareaDraggable />
        <NumberDraggable />
        <NumberRangeDraggable />
        <DateDraggable />
        <DateRangeDraggable />
        <ListDraggable />
        <RadioDraggable />
        <CheckboxDraggable />
        <ImageUploadDraggable />
        <DownloadDraggable />
      </div>
    </div>
  )
}
